module.exports = __webpack_public_path__ + "assets/img/sabc_auth_news_sec_bg.webp?4ecd93add5dac28556fe602d035725b5";